import Header from "../components/Header";
import SignIn from "../components/sign-in";

export default function Register() {
  return (
    <>
      <SignIn />
    </>
  );
}
